import React, {useEffect} from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import EditProfile from "component/EditProfile";
import { popinfo } from "component/Fancybox/Fancybox";
import "./index.scss";
import { useState } from "react";
import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import EditProfilePicture from "component/EditProfilePicture";
import { PageCredential } from "component/PageCredential";

const PageProfileEdit = connect(stateMap)((props) => {
    const[eligibility, setEligibility]  = useState(false);
    const[profile, setProfile]          = useState(false);
    const[socmeds, setSocmeds]          = useState([]);

    useEffect(() => {

        if(!props.auth.user)
        {
            return;
        }

        Promise.all([
            api('/BasicProfile', 'get', {}, 'Bearer ' + props.auth.token)
            ,api('/UserSocmeds', 'get', { user_id : props.auth.user.UserID })
        ]).then(response => {
            setProfile(response[0].user);
            setSocmeds(response[1].accounts);
            setEligibility(true);
        })
        .catch((error) => {
            setEligibility('PROFILE_ERROR');
        });

    }, [props.auth.user]);

    return (
        props.auth.user &&
        <div className="page-profile-edit container w-800">
            <PageCredential title={"Edit Profile"}/>
            <BlockHeader title="Update Profile" link={{
                pathname : "/profile"
            }} link_text="Return To Profile"/>
            <hr />
            {
                eligibility === false && <span className="skeleton"></span>
            }
            {
                eligibility === true &&
                <>
                    <EditProfilePicture/>
                    <EditProfile 
                        profile={profile} 
                        socmeds={socmeds}
                        submitButtonText="Save Profile"
                        onSubmit={values => {
                            var SavingLoader = popinfo('loader', 'Saving Profile', 'Please Wait');

                            Promise.all([
                                api('/BasicProfile', 'post', values, 'Bearer ' + props.auth.token)
                                ,api('/UserSocmeds', 'post', values, 'Bearer ' + props.auth.token)
                            ]).then(() => {
                                popinfo('ok', 'Saving Profile', 'Profile Successfully Saved', {
                                    autoHide : true
                                }, SavingLoader);
                            })
                            .catch((error) => {
                                popinfo('error', 'Saving Data', error, {}, SavingLoader);
                            });

                        }}
                    />
                </>
            }
            <div className="leading-text text-md text-center bold">
                { eligibility === 'PROFILE_ERROR' && <span className="textarea">Invalid token found</span> }
                { eligibility === 'QUERY_INCOMPLETE' && <span className="textarea">Missing identification token on URL</span> }
            </div>
        </div>
    )
});

export default PageProfileEdit;